import { create } from "jss";
import { jssPreset, createGenerateClassName } from "@material-ui/core/styles";

if (document.head.childNodes.length == 0
    || (document.head.childNodes[1].nodeType !== 8
        && document.head.childNodes[1].nodeValue !== "insertion-point-jss")) {
    const styleNode = document.createComment("insertion-point-jss");
    document.head.insertBefore(styleNode, document.head.firstChild.nextSibling);
}

const jss = create({
    ...jssPreset(),
    insertionPoint: "insertion-point-jss"
});

const getClassGen = function (pre) {
    return createGenerateClassName({
        productionPrefix: pre ? 'pre' : 'c'
    });
};

export default jss;
export { getClassGen };